module.exports = __webpack_public_path__ + "media/images/receive-a2df3016c31d3aaad39efbcbe47c6084.png";